module.exports = __webpack_public_path__ + "img/Noah.cedc0174.jpeg";